// export const baseURL =
//   "https://r09gru3n82.execute-api.us-east-1.amazonaws.com/dev/";
// export const baseURL = "https://dev.sitecareerpathways.gmsgq.onetakeda.com/";
export const baseURL = "/";
